import React from "react";
import styled from "styled-components";
import { FileText, X } from "lucide-react";
import { Typography } from "../../general/Typography";
import { Flex } from "../../layouts/wrappers/Flex";
import { Button } from "../../general/Button";

interface UploadedFileItemProps {
  fileName: string;
  fileSize?: number;
  onRemove?: () => void;
}

const ItemWrapper = styled(Flex)`
  width: 100%;
  background: ${({ theme }) => theme.colors.surfaceHover};
  border-radius: ${({ theme }) => theme.radii.md};
  padding: ${({ theme }) => theme.spacing.sm};
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm};
  box-shadow: ${({ theme }) => theme.elevations.low};
`;

const FileInfo = styled(Flex)`
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  overflow: hidden;

  .filename {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 140px;
    }
  }
`;

export const UploadedFileItem: React.FC<UploadedFileItemProps> = ({
  fileName,
  fileSize,
  onRemove,
}) => {
  const readableSize = fileSize
    ? `${(fileSize / 1024).toFixed(1)} KB`
    : undefined;

  return (
    <ItemWrapper>
      <FileInfo>
        <FileText size={20} />
        <div>
          <Typography as="span" variant="body" className="filename">
            {fileName}
          </Typography>
          {readableSize && (
            <Typography as="div" variant="caption" colorScheme="muted">
              {readableSize}
            </Typography>
          )}
        </div>
      </FileInfo>

      {onRemove && (
        <Button
          variant="ghost"
          size="compact"
          onClick={onRemove}
          aria-label="Remove file"
        >
          <X size={18} />
        </Button>
      )}
    </ItemWrapper>
  );
};